import React, { useEffect, useState } from "react";
import "./styles.less";
import { AuthenticationClient } from "authing-js-sdk";
import { Modal } from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { dateFormat } from "../../utils";
import { ModalUsePortal } from "../ModalUsePortal";

let CodeMirror = null;
if (typeof window !== "undefined" && typeof window.navigator !== "undefined") {
  const { Controlled } = require("react-codemirror2");
  CodeMirror = Controlled;
  require("codemirror/lib/codemirror.css");
  require("codemirror/theme/material.css");
  require("codemirror/mode/htmlembedded/htmlembedded");
}

export const VerifyScan = () => {
  const [userInfo, setUserInfo] = useState({});
  const [userInfoVisible, setUserInfoVisible] = useState(false);
  const [userInfoType, setUserInfoType] = useState("ordinary");
  const { t } = useTranslation();
  useEffect(() => {
    const auth = new AuthenticationClient({
      userPoolId: "5d1eeec1ec626c2abb803a24", //5d11dcc331f4173231ed6a8d
      // timestamp: Math.round(new Date() / 1000),
      // nonce: Math.ceil(Math.random() * Math.pow(10, 6)),
      // useSelfWxapp: true,
      // noSecurityChecking: true,
    });
    const onScanningSuccess = async (userInfo) => {
      console.log(userInfo, "userInfo");
      setUserInfo(userInfo.data);
      // setUserInfoVisible(true);
    };
    auth.wxqrcode.startScanning("qrcode-node", {
      onSuccess: onScanningSuccess,
      // onError: (message) => onFail && onFail(`${message}`),
    });

    // 调用小程序扫码登录的方法，此方法将生成一个用于扫码登录的图片和相关提示信息
    // auth.startWXAppScaning({
    //   mount: "qrcode-node",
    //   tips: "使用微信扫码",
    //   // 不自动跳转
    //   redirect: false,

    //   // 扫码成功
    //   onSuccess(userInfo) {
    //     setUserInfo(userInfo.data);
    //     setUserInfoVisible(true);
    //   },
    // });
  }, []);

  return (
    <div className="verify-wx-mini-scan">
      <div className="qrcode-node" id="qrcode-node"></div>
      {/* <div className="qrcode-node-modal">
        <ModalUsePortal
          show={userInfoVisible}
          modalClassName="qrcode-node-modal"
        >
          <div className="user-info-modal">
            <div className="user-info-header">
              {t("learn.verify.banner.userInfo")}
              <div>
                <a
                  className="link-button"
                  href="http://docs.authing.cn/scan-qrcode/wxapp-qrcode/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("learn.verify.scan.modal.doc")}
                </a>
                |
                {userInfoType === "ordinary" ? (
                  <span
                    className="link-button"
                    onClick={() => {
                      setUserInfoType("json");
                    }}
                  >
                    {t("learn.verify.scan.modal.json-mode")}
                  </span>
                ) : (
                  <span
                    className="link-button"
                    onClick={() => {
                      setUserInfoType("ordinary");
                    }}
                  >
                    {t("learn.verify.scan.modal.ordinary-mode")}
                  </span>
                )}
                <i
                  onClick={() => setUserInfoVisible(false)}
                  className="icon authing-icon authing-guanbi"
                  style={{ marginLeft: 10 }}
                />
              </div>
            </div>
            {userInfoType === "ordinary" && (
              <div className="usef-info-content">
                <div className="content-tip">
                  {t("learn.verify.scan.modal.welcom")} {userInfo.phone}
                </div>
                <div className="content-title">
                  {t("learn.verify.scan.modal.base-info")}
                </div>
                <div className="content-item-warp">
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.username")}
                    </div>
                    <div className="text">{userInfo.username}</div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.phone")}
                    </div>
                    <div className="text">{userInfo.phone}</div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.time")}
                    </div>
                    <div className="text">{dateFormat(userInfo.lastLogin)}</div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.user-id")}
                    </div>
                    <div className="text">{userInfo.id}</div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.userpool-id")}
                    </div>
                    <div className="text">{userInfo.userPoolId}</div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.open-id")}
                    </div>
                    <div className="text">{userInfo.openid}</div>
                  </div>
                </div>
                <div className="content-title">
                  {t("learn.verify.scan.modal.address-info")}
                </div>
                <div className="content-item-warp">
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.city")}
                    </div>
                    <div className="text">{userInfo.city}</div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.country")}
                    </div>
                    <div className="text">{userInfo.country}</div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.region")}
                    </div>
                    <div className="text">
                      {userInfo.region ? userInfo.region : "--"}
                    </div>
                  </div>
                  <div className="content-item">
                    <div className="label">
                      {t("learn.verify.scan.modal.client-ip")}
                    </div>
                    <div className="text">{userInfo.lastIP}</div>
                  </div>
                </div>
              </div>
            )}
            {userInfoType === "json" && CodeMirror && (
              <CodeMirror
                value={JSON.stringify(userInfo, null, 2)}
                autoScroll={false}
                className={"user-info-code"}
                options={{
                  mode: { name: "javascript", json: true },
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            )}
          </div>
        </ModalUsePortal>
      </div> */}
    </div>
  );
};
